import {
  CorporateUserDealershipLogRequest,
  HttpHelper,
  IAuth0User,
  ICoxUser,
  IListDealershipsPagedResponse,
  ListDealershipsPagedParams,
} from "c4u-web-components";
import { useRequest, c4uHttp } from "./../config";

export const useC4u = () => {
  const { get, post } = useRequest(c4uHttp, "");

  const GetUser = async (): Promise<ICoxUser> => {
    const { data } = await get(`Admin/User`);
    return data;
  };

  const GetAuth0User = async (): Promise<IAuth0User> => {
    const { data } = await get(`Admin/Auth0User`);
    return data;
  };

  const postSelectDealership = async (
    request: CorporateUserDealershipLogRequest
  ): Promise<void> => {
    await post("LoginLog/createCorporateUserDealershipLog", request);
  };

  const getListMyDealerships = async (
    params: ListDealershipsPagedParams
  ): Promise<IListDealershipsPagedResponse> => {
    const { data } = await get(
      `Admin/listMyDealerships${HttpHelper.BuildQueryString(params)}`
    );
    return data;
  };

  return {
    GetAuth0User,
    GetUser,
    postSelectDealership,
    getListMyDealerships,
  };
};
